import { gunterzBold } from '@/theme/fonts';
import { Box, Card, Group, NumberFormatter, Text } from '@mantine/core';
import { DepositButton } from './DepositButton';
export type ProfileBalanceProps = {
  title: string;
  value: number;
};
export const ProfileBalance: React.FC<ProfileBalanceProps> = ({
  title,
  value
}) => {
  return <Card p={{
    base: 16,
    sm: 20
  }} bg="var(--navbar-bg-color)" radius={5}>
      <Group justify="space-between">
        <Box>
          <Text tt="uppercase" c="var(--text-prime)" fz={{
          base: 12,
          sm: 13
        }} fw={700}>
            {title}
          </Text>
          <Text fw={700} fz={{
          base: 21,
          sm: 24,
          md: 21
        }} mt={12} className={gunterzBold.className}>
            <NumberFormatter value={value} prefix="$" thousandSeparator="," decimalScale={3} decimalSeparator="." />
          </Text>
        </Box>
        <DepositButton />
      </Group>
    </Card>;
};